const width = 640,
      height = 360;

/**
 * From a given video id, render a vimeo iframe.
 *
 * @param {String} videoId The video id to see.
 * @param {String} title The video title/legend.
 * @return {String} The HTML ready to be used.
 */
function getVimeoEmbededVideo(videoId, title) {
    var out = "<div class=\"vimeo-player-container\">" +
        "<iframe src=\"https://player.vimeo.com/video/" + videoId + "\" " +
        "class =\"vimeo-player-iframe\"" +
        "width=\"" + width + "\" height=\"" + height + "\" frameborder=\"0\" " +
        "webkitallowfullscreen " +
        "mozallowfullscreen allowfullscreen></iframe></div>";

    if (title) {
        out += "<small class=\"text-center legend\"><i>" + title + "</i></small>";
    }

    return out;
}

/**
 * From a given video id, render a youtube iframe.
 *
 * @param {String} videoId The video id to see.
 * @param {String} title The video title/legend.
 * @return {String} The HTML ready to be used.
 */
function getYoutubeEmbededVideo(videoId, title) {
    var out = "<div class=\"youtube-player-container\">" +
        "<iframe width=\"" + width + "\" height=\"" + height + "\" " +
        "class=\"youtube-player-iframe\" " +
        "src=\"https://www.youtube.com/embed/" + videoId +
        "?enablejsapi=1&version=3&playerapiid=ytplayer\" " +
        "frameborder=\"0\" allow=\"autoplay; encrypted-media\" " +
        "allowfullscreen allowscriptaccess=\"always\"></iframe></div>";

    if (title) {
        out += "<small class=\"text-center legend\"><i>" + title + "</i></small>";
    }

    return out;
}

/**
 * From a given video id, render a dailymotion iframe.
 *
 * @param {String} videoId The video id to see.
 * @param {String} title The video title/legend.
 * @return {String} The HTML ready to be used.
 */
function getDailymotionEmbededVideo(videoId, title) {
    var out = "<div class=\"dailymotion-player-container\">" +
        "<iframe frameborder=\"0\" width=\"" + width + "\" height=\"" + height + "\" " +
        "class=\"dailymotion-player-iframe\" " +
        "src=\"https://www.dailymotion.com/embed/video/" + videoId + "?queue-enable=false&api=postMessage\"" +
        "allowfullscreen allow=\"autoplay\"></iframe></div>";

    if (title) {
        out += "<small class=\"text-center legend\"><i>" + title + "</i></small>";
    }

    return out;
}

/**
 * From a given video id, render a facebook iframe.
 *
 * @param {String} url The video url to see.
 * @param {String} title The video title/legend.
 * @return {String} The HTML ready to be used.
 */
function getFacebookEmbededVideo(url, title) {
    var out = "<div class=\"facebook-player-container\">" +
        "<iframe src=\"https://www.facebook.com/plugins/video.php?href=" + encodeURIComponent(url) +
        "&show_text=0&width=" + width + "\" width=\"" + width + "\" height=\"" + height + "\" " +
        "style=\"border:none;overflow:hidden\" class=\"facebook-player-iframe\" " +
        "scrolling=\"no\" frameborder=\"0\" allowTransparency=\"true\" allowFullScreen=\"true\"></iframe></div>";

    if (title) {
        out += "<small class=\"text-center legend\"><i>" + title + "</i></small>";
    }

    return out;
}

/**
 * Get vimeo video id.
 *
 * @param {String} url The href link to test.
 * @return {String | Boolean} A String if video id has been found, undefined otherwise.
 */
function getVimeoVideoId(url) {
    // eslint-disable-next-line
    var regExp = /^.*(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?).*/;
    var match = url.match(regExp);
    return (match && match.length > 3) ? match[3] : undefined;
}

/**
 * Get youtube video id.
 *
 * @param {String} url The href link to test.
 * @return {String | Boolean} A String if video id has been found, undefined otherwise.
 */
function getYoutubeVideoId(url) {
    // eslint-disable-next-line
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length==11)? match[7] : undefined;
}

/**
 * Get dailymotion video id.
 *
 * @param {String} url The href link to test.
 * @return {String | Boolean} A String if video id has been found, undefined otherwise.
 */
function getDailymotionVideoId(url) {
    // eslint-disable-next-line
    var regExp = /^.*(?:www\.)?((dailymotion.com\/|dai.ly\/)|(hub\/)|(video\/))([^_]+).*/;
    var match = url.match(regExp);
    return (match && match.length > 5) ? match[5] : undefined;
}

/**
 * Get facebook video id.
 *
 * @param {String} url The href link to test.
 * @return {String | Boolean} A String if video id has been found, undefined otherwise.
 */
function getFacebookVideoId(url) {
    // eslint-disable-next-line
    var regExp = /^.*(?:www\.)?(facebook.com\/)([^\/]+\/)(videos\/)([^\/]+).*/;
    var match = url.match(regExp);
    return (match && match.length > 4) ? match[4] : undefined;
}

function create(useProxyForImage) {
    const renderer = new marked.Renderer();

    renderer.link = function(href, title, text) {
        var youtubeVideoId = getYoutubeVideoId(href);
        if (youtubeVideoId) {
            return getYoutubeEmbededVideo(youtubeVideoId, text);
        }
        var facebookVideoId = getFacebookVideoId(href);
        if (facebookVideoId) {
            return getFacebookEmbededVideo(href, text);
        }
        var vimeoVideoId = getVimeoVideoId(href);
        if (vimeoVideoId) {
            return getVimeoEmbededVideo(vimeoVideoId, text);
        }
        var dailymotionVideoId = getDailymotionVideoId(href);
        if (dailymotionVideoId) {
            return getDailymotionEmbededVideo(dailymotionVideoId, text);
        }
        var out = "<a href=\"" + href + "\" target=\"_blank\"";
        if (title) {
            out += " title=\"" + title + "\"";
        }
        out += ">" + text + "</a>";
        return out;
    };

    renderer.image = function (href, title, text) {
        var youtubeVideoId = getYoutubeVideoId(href);
        if (youtubeVideoId) {
            return getYoutubeEmbededVideo(youtubeVideoId, title);
        }
        var facebookVideoId = getFacebookVideoId(href);
        if (facebookVideoId) {
            return getFacebookEmbededVideo(href, title);
        }
        var vimeoVideoId = getVimeoVideoId(href);
        if (vimeoVideoId) {
            return getVimeoEmbededVideo(vimeoVideoId, title);
        }
        var dailymotionVideoId = getDailymotionVideoId(href);
        if (dailymotionVideoId) {
            return getDailymotionEmbededVideo(dailymotionVideoId, title);
        }
        const url = (useProxyForImage === true) ? "/proxy/image?url=" + encodeURIComponent(href) : href;
        var out = "<img src=\"" + url + "\" alt=\"" + text + "\" />";
        if (title) {
            out += "<small class=\"text-center legend\"><i>" + title + "</i></small>";
        }
        return out;
    }

    renderer.checkbox = function(checked) {
        return "<input "
          + (checked ? "checked=\"\" " : "")
          + " type=\"checkbox\""
          + (this.options.xhtml ? " /" : "")
          + "> ";
    }
    return renderer;
}

export default create;